import { useParams } from "react-router-dom";
import BackButton from "src/components/BackButton";
import Chat from "src/components/chat/Chat";
import InboxList from "src/components/lists/InboxList";
import Layout from "src/components/layout/Layout";
import useWindowSize from "src/hooks/useWindowSize";
import ChatProvider from "src/components/chat/ChatProvider";
import TaskChat from "src/components/chat/chats/TaskChat";
import OfferChat from "src/components/chat/chats/OfferChat";
import useAuth from "src/hooks/selectors/useAuth";
import { useTranslation } from "react-i18next";
import useSubscription from "src/hooks/selectors/useSubscription";
import SubscriptionFeatureMiddleware from "src/components/middlewares/SubscriptionFeatureMiddleware";

const DashboardInboxView = () => {
	const { t } = useTranslation("inbox-view", {
		keyPrefix: "inbox-view",
	});
	const params = useParams() as any;
	const size = useWindowSize();
	const auth = useAuth();
	const subscription = useSubscription();
	if (auth.type === "company" && !subscription?.id) {
		return (
			<Layout title={t("title")}>
				<SubscriptionFeatureMiddleware plan="all" />
			</Layout>
		);
	}

	return (
		<Layout title={t("title")}>
			<div
				className={
					!size.isTablet
						? "grid grid-cols-[430px,1fr] gap-8 flex-1"
						: "flex flex-col flex-1"
				}
			>
				{(!size.isTablet || !params.id) && (
					<InboxList variant="light" />
				)}

				{!params.id && !size.isTablet && (
					<div className="col-span-2 flex flex-1 justify-center items-center flex-col">
						<strong>{t("select")}</strong>
					</div>
				)}
				{params?.id && (
					<ChatProvider id={params.id}>
						{(loading, data) => {
							if (loading) {
								return <Chat.Loading className="flex-1" />;
							}

							if (!data || !data?.registration) {
								return (
									<div className="flex flex-1 justify-center items-center flex-col">
										<strong>{t("not-found")}</strong>
									</div>
								);
							}
							const { task, registration, offer, type } = data;

							return (
								<div className="flex flex-1 flex-col gap-3">
									<div className="h-10 flex">
										<BackButton
											to={`/inbox`}
											label={t("back")}
										/>
									</div>
									{type === "task" &&
										task &&
										registration && (
											<TaskChat
												{...{ task, registration }}
											/>
										)}
									{type === "offer" && offer && (
										<OfferChat
											variant={
												auth.type === "company" &&
												size.isDesktop
													? "full"
													: "modal"
											}
											{...{ offer, registration }}
										/>
									)}
								</div>
							);
						}}
					</ChatProvider>
				)}
			</div>
		</Layout>
	);
};

export default DashboardInboxView;
